var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    ref: "notificationsConfirmationModal",
    attrs: {
      "id": _vm.modalId || 'bv-notifications-confirmation',
      "scrollable": "",
      "centered": "",
      "cancel-disabled": "",
      "ok-disabled": "",
      "no-stacking": "",
      "hide-header": "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "size": "lg"
    }
  }, [_c('div', {
    staticClass: "padding"
  }, [_c('VHeader', {
    attrs: {
      "modal-button": true
    },
    on: {
      "close-modal": _vm.closeModal
    },
    scopedSlots: _vm._u([{
      key: "modal-title",
      fn: function () {
        return [_vm._v(_vm._s(_vm.title))];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('p', [_vm._v("\n        When your job is complete, you'll see a notification appear in the\n        tray.\n      ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.gifSrc,
      "alt": "A numbered badge appears on the notification tray button in the page header. Interacting with that button reveals the notification tray. Toasts that prompt the badge are announced to screen readers."
    }
  }), _vm._v(" "), _c('VButton', {
    staticClass: "primary",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Continue")])], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }